'use client';
import React, { useEffect, useRef, useState } from 'react';

export default function CustomCTABanner() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="relative bg-primary py-14 lg:py-20 overflow-hidden green-pattern"
      id="custom-packaging"
    >
      {/* Decorative leaf icons */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[
          { top: '10%', left: '3%', rotate: '-15deg', size: 40 },
          { top: '60%', left: '8%', rotate: '20deg', size: 30 },
          { top: '20%', right: '5%', rotate: '10deg', size: 35 },
          { top: '70%', right: '10%', rotate: '-20deg', size: 28 },
          { top: '40%', left: '15%', rotate: '5deg', size: 22 },
          { top: '30%', right: '18%', rotate: '-10deg', size: 25 },
        ]?.map((pos, i) => (
          <div
            key={i}
            className="absolute opacity-20"
            style={{ top: pos?.top, left: pos?.left, right: pos?.right, transform: `rotate(${pos?.rotate})` }}
          >
            <svg width={pos?.size} height={pos?.size} viewBox="0 0 40 40" fill="none">
              <path d="M20 4 C10 4 4 14 4 20 C4 30 14 36 20 36 C26 36 36 30 36 20 C36 14 30 4 20 4Z" fill="white" />
              <path d="M20 4 L20 36" stroke="white" strokeWidth="1.5" opacity="0.5" />
            </svg>
          </div>
        ))}
      </div>
      <div
        className={`relative max-w-2xl mx-auto text-center px-6 transition-all duration-600 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block bg-white/20 text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4">
          Custom Packaging
        </span>
        <h2
          className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3"
          style={{ fontFamily: 'Fraunces, serif' }}
        >
          One supplier for everything your brand ships.
        </h2>
        <p className="text-white/80 text-base font-normal mb-7">
          Boxes, bags, mailers, labels — all eco-friendly, all custom-branded, all from one place. Tell us what you need.
        </p>
        <a href="#contact" className="inline-flex items-center gap-2 bg-white text-primary font-semibold px-8 py-3 rounded-btn hover:bg-gray-50 transition-all duration-200 hover:scale-105 active:scale-95">
          Customize Now
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
          </svg>
        </a>
      </div>
    </section>
  );
}
